/*
 * @Author: luting
 * @Date: 2022-05-05 19:53:50
 * @lastEditors: luting
 * @LastEditTime: 2023-07-26 10:32:57
 */
import React, { useState, useEffect, createRef } from 'react';
import { FormComponentProps } from 'sup-ui/lib/form';
import { Button } from 'sup-ui';
import { useIntl } from 'react-intl';
import messages from './messages';

import NoticeForm from './NoticeForm';
import CommonModal from 'root/components/CommonModal';

import { getNoticeApi, updateNoticeApi, testNoticeApi } from 'root/services/notice';
import { IStatus, ITestLinkStatus, INoticeType } from './types';
import CryptoJS from 'crypto-js';
import styles from './index.less';

type Ref = FormComponentProps;

const Notice = () => {
  const intl = useIntl();
  const noticeFormRef = createRef<Ref>();
  const [visible, setVisible] = useState(false);
  const [spinStatus, setSpinStatus] = useState<IStatus>({ status: false, message: '' });
  const [testStatus, setTestStatus] = useState<ITestLinkStatus>({ showTip: false, status: false, message: '' });
  const [record, setRecord] = useState<INoticeType | null>(null);
  const [btnWord, setBtnWord] = useState('testLink'); // 测试链接按钮文字
  const [errorStatsu, setErrorStatus] = useState(false); // 测试失败时,form表单显示error状态

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    getNoticeApi().then((res) => {
      const { data = {} } = res;
      setRecord(data);
    });
  };

  const editEvent = () => {
    getData();
    setVisible(true);
    setErrorStatus(false);
    setBtnWord('testLink');
    setTestStatus({
      showTip: false,
      status: false,
      message: '',
    });
    setSpinStatus({
      message: '',
      status: false,
    });
  };

  // 处理密码
  const handlePassword = (password: string) => {
    // 如果密码没有修改过，不需要加密
    if (record?.mailPassword === password) return password;
    // 加密
    const wordArray = CryptoJS.enc.Utf8.parse(password);
    const base64 = CryptoJS.enc.Base64.stringify(wordArray);
    return base64;
  };

  // 特殊点: 如果一开始getNoticeApi的data是null就说明之前没有数据,那么就是新增不需要传id.如果时更新就必须传id
  const onOk = () => {
    noticeFormRef?.current?.form.validateFields((err: any, values: any) => {
      if (err) return;
      setSpinStatus({
        status: true,
        message: intl.formatMessage(messages.doing),
      });
      setBtnWord('testLink');
      const { ssl, mailPassword, alertMailSend, mails } = values;

      // 修改发件人的value值为发件人邮箱
      const newReceiverMails = mails.map((item: string) => {
        if (item === 'current') {
          return alertMailSend;
        }
        return item;
      });

      const params = {
        ...values,
        ssl: ssl ? 1 : 0,
        mailPassword: handlePassword(mailPassword),
        id: record?.id ? record.id : undefined,
        mails: newReceiverMails,
      };
      updateNoticeApi(params)
        .then(() => {
          setVisible(false);
          // 获取最新数据
          getData();
        })
        .finally(() => {
          setSpinStatus({
            status: false,
            message: '',
          });
          closeTip();
        });
    });
  };

  // 关闭测试链接
  const closeTip = () => {
    setTestStatus({
      showTip: false,
      status: false,
      message: '',
    });
  };

  // 链接测试
  const testLinkEvent = () => {
    noticeFormRef?.current?.form.validateFields((err: any, values: any) => {
      if (err) return;
      let { mailPassword } = values;
      const { mails, alertMailSend, ssl } = values;

      setSpinStatus({
        status: true,
        message: intl.formatMessage(messages.linking),
      });
      setBtnWord('linking');

      mailPassword = handlePassword(mailPassword);
      // 修改发件人的value值为发件人邮箱
      const newReceiverMails = mails.map((item: string) => {
        if (item === 'current') {
          return alertMailSend;
        }
        return item;
      });

      const params = {
        ...values,
        ssl: ssl ? 1 : 0,
        mailPassword,
        id: record?.id ? record.id : undefined,
        mails: newReceiverMails,
      };
      setTimeout(() => {
        testLinkService(params);
      }, 1000);
    });
  };

  // 测试链接的api
  const testLinkService = (params: any) => {
    let tempStatus: ITestLinkStatus = {
      showTip: true,
    };

    testNoticeApi(params)
      .then((res) => {
        const {
          data: { message = '', success },
        } = res;

        if (!success) {
          setErrorStatus(true);
        }
        tempStatus = {
          ...tempStatus,
          status: success,
          message: success ? intl.formatMessage(messages.success) : message,
        };
        setTestStatus(tempStatus);
      })

      .finally(() => {
        setTestStatus(tempStatus);
        setSpinStatus({
          status: false,
          message: '',
        });
        setBtnWord('testLink');
      });
  };

  const cancelEvent = () => {
    noticeFormRef?.current?.form.resetFields();
    setVisible(false);
    setSpinStatus({
      message: '',
      status: false,
    });
    closeTip();
  };

  return (
    <div className={styles.noticeSetBox}>
      <div className={styles.warnBox}>
        <NoticeForm
          errorStatsu={false}
          testStatus={testStatus}
          spinStatus={{ message: '', status: false }}
          disable={true}
          record={record}
        />
        <Button onClick={editEvent}>{intl.formatMessage(messages.update)}</Button>
      </div>

      <CommonModal
        title={intl.formatMessage(messages.updateNoticeSet)}
        visible={visible}
        height="auto"
        onCancel={() => setVisible(false)}
        forceRender={true}
        footer={[
          <Button disabled={spinStatus.status} style={{ float: 'left' }} key="link" onClick={testLinkEvent}>
            {intl.formatMessage(messages[btnWord])}
          </Button>,
          <Button disabled={spinStatus.status} type="primary" key="ok" onClick={onOk}>
            {intl.formatMessage(messages.ok)}
          </Button>,
          <Button key="cancel" disabled={spinStatus.status} onClick={cancelEvent}>
            {intl.formatMessage(messages.cancel)}
          </Button>,
        ]}
        destroyOnClose
      >
        <NoticeForm
          testStatus={testStatus}
          spinStatus={spinStatus}
          disable={false}
          wrappedComponentRef={noticeFormRef}
          record={record}
          errorStatsu={errorStatsu}
        />
      </CommonModal>
    </div>
  );
};

export default Notice;
